import React, { PureComponent } from 'react';
import ProgressBar from './ProgressBar';
import qMark from '../images/q-mark.svg';

class Sidebar extends PureComponent {
    render() {
        const { categoryID, categoryData } = this.props;
        
        return (
            <div className="questionpage-sidebar">
                <div className={categoryID != 11 ? 'sidebar' : 'sidebar __job'}>
                    <div className="sidebar-progress">
                        <ProgressBar categoryID={categoryID} />
                    </div>

                    {categoryID !== 11 && categoryData ? (
                        <div className="sidebar-wrap">
                            <h2 className={`sidebar-category ${categoryData.category.class}`}>{categoryData.category.title}</h2>
                        </div>
                    ) : (
                        <div className="sidebar-wrap __job">
                            <h1 className="sidebar-title">
                                Your<br />occupation.
                            </h1>
                            <div className="sidebar-notice">
                                <div className="notice">
                                    <h5 className="notice-title">
                                        <img src={qMark} alt="" />
                                        Can't find your occupation?
                                    </h5>

                                    <ul className="notice-list">
                                        <li>Avoid abbreviations and slang</li>
                                        <li>
                                            In some cases, your occupation won't be listed so you'll
                                            need to choose the closest match.
                                            <br />
                                            <strong>e.g</strong> an 'Otter Keeper' could use
                                            'Animal Keeper' and a 'Science Teacher' could use 'Secondary School Teacher' instead.
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/Question/Sidebar.js